"use strict";
/**
 * Collaborator Constants and Enums
 *
 * Shared enums used by both backend and frontend for collaborator management.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gender = exports.Degree = exports.WebAppRole = void 0;
/**
 * Web Application Roles
 *
 * Defines user roles for authorization and access control.
 * Used in JWT tokens, middleware, and UI role-based rendering.
 */
var WebAppRole;
(function (WebAppRole) {
    WebAppRole["admin"] = "Administrador";
    WebAppRole["manager"] = "Gerente";
    WebAppRole["collaborator"] = "Colaborador";
    WebAppRole["user"] = "User";
    WebAppRole["guest"] = "Invitado";
    WebAppRole["no_access"] = "Sin acceso";
})(WebAppRole || (exports.WebAppRole = WebAppRole = {}));
/**
 * Educational Degree
 *
 * Academic level of collaborators for HR records.
 */
var Degree;
(function (Degree) {
    Degree["HighSchool"] = "Bachillerato";
    Degree["UniversityStudent"] = "Estudiante universitario";
    Degree["BachelorComplete"] = "Licenciatura completa";
    Degree["Graduated"] = "Titulado";
    Degree["Masters"] = "Maestr\u00EDa";
    Degree["Doctorate"] = "Doctorado";
    Degree["Other"] = "Otros";
})(Degree || (exports.Degree = Degree = {}));
/**
 * Gender
 *
 * Gender identification for HR and demographic records.
 */
var Gender;
(function (Gender) {
    Gender["Male"] = "Masculino";
    Gender["Female"] = "Femenino";
    Gender["Other"] = "Otro";
})(Gender || (exports.Gender = Gender = {}));
